var text_field_default = {
  "root": "_69ViO",
  "text": "_2DTg2",
  "input": "Wa-w9",
  "small": "QCsSS",
  "medium": "iZeec",
  "large": "Xbf37",
  "webview": "lqFDS",
  "endAdornment": "lNyar",
  "shown": "aF9Zk",
  "value": "Qh0zG",
  "spinner": "q42s-",
  "spin": "cEstg"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
